import axios from "axios";
import { msalInstance } from "../index";
import { loginRequest } from "../config/authConfig";

const setupAxiosInterceptor = () => {
  axios.interceptors.request.use(
    async (config) => {
      try {
        const isSasUrl =
          config.url?.includes("apisaoniken.azure-api.net") ||
          config.url?.includes("logic.azure.com") ||
          config.headers?.["Ocp-Apim-Subscription-Key"];

        if (!isSasUrl) {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            const response = await msalInstance.acquireTokenSilent({
              ...loginRequest,
              account: accounts[0],
            });

            if (response.accessToken) {
              config.headers.Authorization = `Bearer ${response.accessToken}`;
            }
          }
        }
      } catch (error) {
        console.error("Error acquiring token:", error);
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        try {
          await msalInstance.acquireTokenPopup(loginRequest);
          return axios(error.config);
        } catch (msalError) {
          console.error("Token refresh failed:", msalError);
          msalInstance.logoutPopup();
        }
      }
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptor;
